let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lmguf")).then(() => parcelRequire('jGHO9'));